















































import Enumerable from "linq";
import { Component, Mixins, } from "vue-property-decorator";
import { ReceptionDispInfo } from "../../../domain/workflow";
import { ReceptionCommentKinds } from "../../../domain/workflow/kinds";
import { DialogMixin } from "../../system/mixins";
import { default as CommentEditor, instanceOfICommentEditor } from "../editors/controls/CommentEditor.vue";
import { IReferenceCommentListTableCondition } from "../lists/tables/IReferenceCommentListTableCondition";
import { ICommentSelectableDialogCondition } from "./ICommentSelectableDialogCondition";

interface ICommentKindOption {
  kind: ReceptionCommentKinds;
  name: string;
}

export interface ICommentSelectableDialogResult {
  isConfirmed: boolean;
  kind: ReceptionCommentKinds;
  comment: string;
}

@Component({
  components: {
    CommentEditor,
  }
})
export default class CommentSelectableDialog extends Mixins(DialogMixin) {
  $refs!: {
    commentEditor: CommentEditor;
  };

  data(): any {
    return {
      isConfirmed: false,
      title: "",
      note: "",
      labelSetting: null,
      defaultAdditionalCommentType: null,
      commentKindOptions: this.defaultCommentKindOptions,
      selectedCommentKindOption: null as ICommentKindOption,
      referenceCondition: null,
    };
  }
  isConfirmed: boolean;
  title: string;
  note: string;
  labelSetting: ReceptionDispInfo;
  defaultAdditionalCommentType: ReceptionCommentKinds;
  commentKindOptions: ICommentKindOption[];
  selectedCommentKindOption: ICommentKindOption;
  referenceCondition: IReferenceCommentListTableCondition;

  get receptionDispInfo(): ReceptionDispInfo {
    return this.labelSetting
      ? this.labelSetting
      : new ReceptionDispInfo();
  }

  get isNextMessageSelected(): boolean {
    return this.selectedCommentKindOption && this.selectedCommentKindOption.kind === ReceptionCommentKinds.NextMessage;
  }

  get defaultCommentKindOptions(): ICommentKindOption[] {
    return [
      { kind: ReceptionCommentKinds.NextMessage, name: this.receptionDispInfo.nextMessageLabelName, },
      { kind: ReceptionCommentKinds.Comment, name: this.receptionDispInfo.commentLabelName, },
      { kind: ReceptionCommentKinds.Restrict, name: this.receptionDispInfo.restrictCommentLabelName, },
      { kind: ReceptionCommentKinds.ContactedInfo, name: this.receptionDispInfo.contactedCommentLabelName, },
      { kind: ReceptionCommentKinds.Delete, name: this.receptionDispInfo.delCommentLabelName, },
    ];
  }

  async show(condition: ICommentSelectableDialogCondition): Promise<ICommentSelectableDialogResult> {
    return this.showModal(async () => {
      this.note = "";
      this.isConfirmed = false;
      this.title = condition.name;
      this.labelSetting = condition.labelSetting;
      this.defaultAdditionalCommentType = condition.defaultAdditionalCommentType;
      this.commentKindOptions = this.defaultCommentKindOptions.filter(c => condition.enableKinds.some(k => k === c.kind));
      this.selectedCommentKindOption = (this.defaultAdditionalCommentType !== null && this.commentKindOptions.some(c => c.kind === this.defaultAdditionalCommentType))
        ? Enumerable.from(this.commentKindOptions).where(o => o.kind === this.defaultAdditionalCommentType).firstOrDefault()
        : this.commentKindOptions[0];
      this.referenceCondition = condition.reference;
      await this.$nextTick();
      if (instanceOfICommentEditor(this.$refs.commentEditor)) {
        this.$refs.commentEditor.focus();
        this.$refs.commentEditor.setSelectionRange(this.note.length, this.note.length);
      }
      await this.waitHidden(true);
      this.referenceCondition = null;
      return {
        isConfirmed: this.isConfirmed,
        kind: this.selectedCommentKindOption.kind,
        comment: this.note,
      };
    });
  }

  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }
}
